import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const ImportOrdersFromExcelLazy = loadable(
    () => import(/* webpackChunkName: "ImportOrdersFromExcel" */ './ImportOrdersFromExcel')
);

export const ImportOrdersFromExcelAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <ImportOrdersFromExcelLazy />
    </DelayedSuspense>
);
